import CircleButton from '@components/elements/circle-button/circle-button';
import CrossIcon from '@components/icons/cross-icon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './cart-drawer.module.scss';
import Modal from '@components/elements/modal/modal';

export interface CartModalProps {
  readonly open: boolean;
  toggleOpen(state?: boolean): void;
}

const CartModal: React.FC<React.PropsWithChildren<CartModalProps>> = ({
  children,
  open,
  toggleOpen,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={() => toggleOpen(false)}
      title=""
      hideTitle={true}
      height="fill"
      transparent
    >
      <div className={styles.container}>
        <CircleButton
          className={styles.closeButton}
          label={t('close')}
          hiddenLabel={true}
          onClick={() => toggleOpen(false)}
        >
          <CrossIcon className={styles.closeIcon} />
        </CircleButton>

        {children}
      </div>
    </Modal>
  );
};

export default CartModal;
